export const TRADITIONS = [
  {
    id: "krishna",
    name: "Krishna",
    subtitle: "From the Bhagavad Gita",
    description: "Stories from the Gita and Mahabharata. Warmth, dharma, surrender.",
    image:
      "https://images.unsplash.com/photo-1608387380799-b27ce6ecb723?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "rumi",
    name: "Rumi",
    subtitle: "The Sufi Mystic",
    description: "Parables of divine love, paradox, and heart-shattering tenderness.",
    image:
      "https://images.unsplash.com/photo-1566346289693-a555ded1b37d?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "buddha",
    name: "The Buddha",
    subtitle: "The Awakened One",
    description: "Jataka tales and Dhammapada verses. Clarity, mindfulness, release.",
    image:
      "https://images.unsplash.com/photo-1625888593864-afef418841e7?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "stoic",
    name: "Marcus Aurelius",
    subtitle: "Roman Emperor, Stoic",
    description: "Wisdom from Meditations, Epictetus, Seneca. Reason, duty, grace.",
    image:
      "https://images.unsplash.com/photo-1714393674893-b89e436cc6c4?auto=format&fit=crop&w=400&q=80",
  },
  {
    id: "all",
    name: "The Narrator",
    subtitle: "The voice across traditions",
    description: "Stories drawn from all paths — whichever wisdom fits the moment.",
    image:
      "https://images.unsplash.com/photo-1709139449981-1f97896b3562?auto=format&fit=crop&w=400&q=80",
  },
];

export const traditionById = (id) =>
  TRADITIONS.find((t) => t.id === id) || TRADITIONS[4];

// Landing hero — high-resolution "birds flying over mountain range at golden hour"
// Source: Unsplash / Wolfgang Hasselmann — free to use
export const LANDING_HERO =
  "https://images.unsplash.com/photo-1644664867230-6e59479b0457?auto=format&fit=crop&w=2400&q=85";

export const TIME_BACKGROUNDS = {
  dawn: "https://images.unsplash.com/photo-1765198767658-5012e270117b?auto=format&fit=crop&w=1600&q=80",
  day: "https://images.unsplash.com/photo-1588096344356-9b497e5a3ab5?auto=format&fit=crop&w=1600&q=80",
  dusk: "https://images.pexels.com/photos/32132398/pexels-photo-32132398.jpeg?auto=compress&cs=tinysrgb&w=1600",
  night: "https://images.pexels.com/photos/574115/pexels-photo-574115.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

// Distinct atmospheric scenes per onboarding step (3 steps now)
// Arc: mystical night → warm intimate → dawn forward
export const ONBOARDING_BACKGROUNDS = {
  // 0 - Welcome — stars over Himalayan peaks (mystery, opening the journey)
  0: "https://images.pexels.com/photos/574115/pexels-photo-574115.jpeg?auto=compress&cs=tinysrgb&w=1600",
  // 1 - Tradition picker — candlelight warmth (intimate, sacred teachers)
  1: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?auto=format&fit=crop&w=1600&q=80",
  // 2 - Seeking — mountain path sunrise horizon (dawn, forward, purpose)
  2: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1600&q=80",
};

// Mood-adaptive backgrounds for chat (phase 4)
export const MOOD_BACKGROUNDS = {
  grief: "https://images.unsplash.com/photo-1515694346937-94d85e41e6f0?auto=format&fit=crop&w=1600&q=80",
  fear: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1600&q=80",
  purpose: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1600&q=80",
  hope: "https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1600&q=80",
  anger: "https://images.unsplash.com/photo-1475274047050-1d0c0975c63e?auto=format&fit=crop&w=1600&q=80",
};

export const getTimeOfDay = () => {
  const h = new Date().getHours();
  if (h >= 5 && h < 11) return "dawn";
  if (h >= 11 && h < 16) return "day";
  if (h >= 16 && h < 19) return "dusk";
  return "night";
};

export const getGreeting = () => {
  const tod = getTimeOfDay();
  if (tod === "dawn") return { salute: "Good morning", sub: "A beautiful morning" };
  if (tod === "day") return { salute: "Good afternoon", sub: "The day is still yours" };
  if (tod === "dusk") return { salute: "Good evening", sub: "A golden hour awaits" };
  return { salute: "Good night", sub: "The sky is listening" };
};

export const SEEKING_OPTIONS = [
  { id: "peace", label: "Inner Peace", icon: "Wind" },
  { id: "purpose", label: "Life Purpose", icon: "Compass" },
  { id: "strength", label: "Strength", icon: "Zap" },
  { id: "relationships", label: "Better Relationships", icon: "Heart" },
  { id: "growth", label: "Personal Growth", icon: "Sprout" },
  { id: "wisdom", label: "Spiritual Wisdom", icon: "BookOpen" },
  { id: "decisions", label: "Making Decisions", icon: "Scale" },
  { id: "emotions", label: "Handling Emotions", icon: "Waves" },
];

export const THEMES = [
  { id: "emotions", title: "Emotions", subtitle: "Calm your mind", icon: "Waves", prompt: "My emotions overwhelm me lately. Share a story that helps me hold them gently." },
  { id: "relationships", title: "Relationships", subtitle: "Love & conflict", icon: "Heart", prompt: "I'm struggling in a relationship. Share a story that speaks to love and forgiveness." },
  { id: "purpose", title: "Purpose", subtitle: "Find meaning", icon: "Compass", prompt: "I'm questioning my purpose in life. Tell me a story that speaks to finding one's dharma." },
  { id: "grief", title: "Grief & Healing", subtitle: "Walk through loss", icon: "Moon", prompt: "I am grieving. Tell me a story for the ones who are gone but still carried inside." },
];

export const DIRECT_STARTERS = [
  "I feel lost and don't know my purpose",
  "I'm paralysed by fear of failure",
  "How do I find peace in chaos?",
];